import React from 'react';

import { Button } from '@getgrover/ui';
import { connect } from 'react-redux';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import {
    LayoutComponent_Grid_Col as Col,
    LayoutComponent_Grid_Row as Row,
    LayoutComponent_Text as Text,
} from 'ggApp/modules/layout';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { StoreComponent_StoreShowPrice as ShowPrice } from 'ggApp/modules/store';
import { showDiscount } from 'ggApp/utils/text';
import { RouterComponent_LinkWithStore as Link } from 'ggApp/modules/router';
import { isFunction } from 'ggApp/utils/function';

import {
    StyledColumn,
    StyledRow,
    RowList,
    TaxNote,
    SummaryNote,
    ButtonWrapper,
    OrderTableSummaryWrapper,
    SummaryColumn,
} from './styled';

const CheckoutOrderTableSummary = ({
    orderCurrencySymbol,
    orderSubtotal,
    orderShipping,
    orderDiscount,
    orderVoucherDiscount,
    orderTotal,
    nextLink,
    nextLinkTk,
    buttonLoading,
    buttonOnClick,
    displaySummaryNote,
    children,
    mobile,
    renderButton,
    countryCode,
}) => (
    <OrderTableSummaryWrapper>
        <Row cols={[3.5, 3]}>
            <Col>{children}</Col>
            <SummaryColumn summaryColumn>
                <RowList>
                    <StyledRow>
                        <Translator tk="SUBTOTAL" />
                        <StyledColumn>
                            <ShowPrice
                                price={orderSubtotal}
                                orderCurrencySymbol={orderCurrencySymbol}
                            />
                        </StyledColumn>
                    </StyledRow>

                    <StyledRow>
                        <Translator tk="SHIPPING" />
                        <StyledColumn>
                            <ShowPrice
                                price={orderShipping}
                                orderCurrencySymbol={orderCurrencySymbol}
                            />
                        </StyledColumn>
                    </StyledRow>

                    {!!orderDiscount && parseFloat(orderDiscount) !== 0 && (
                        <StyledRow>
                            <Translator tk="DISCOUNT" />
                            <StyledColumn>
                                -
                                <ShowPrice
                                    price={showDiscount(orderDiscount)}
                                    orderCurrencySymbol={orderCurrencySymbol}
                                />
                            </StyledColumn>
                        </StyledRow>
                    )}

                    {!!orderVoucherDiscount && parseFloat(orderVoucherDiscount) !== 0 && (
                        <StyledRow>
                            <Translator tk="VOUCHER" />
                            <StyledColumn>
                                -
                                <ShowPrice
                                    price={orderVoucherDiscount}
                                    orderCurrencySymbol={orderCurrencySymbol}
                                />
                            </StyledColumn>
                        </StyledRow>
                    )}

                    <StyledRow>
                        <StyledColumn bold>
                            <Translator tk="TOTAL" />
                            <TaxNote>
                                <Translator tk="TAX_APPLY" />
                            </TaxNote>
                        </StyledColumn>
                        <StyledColumn bold>
                            <ShowPrice
                                price={orderTotal}
                                orderCurrencySymbol={orderCurrencySymbol}
                            />
                        </StyledColumn>
                    </StyledRow>
                </RowList>

                {!mobile && (
                    <ButtonWrapper mobile={mobile}>
                        {!isFunction(renderButton) && (
                            <Link to={nextLink} onClick={buttonOnClick}>
                                <Button loading={buttonLoading} primary size="small" fullWidth>
                                    <Translator tk={nextLinkTk} />
                                </Button>
                            </Link>
                        )}

                        {isFunction(renderButton) && renderButton()}
                    </ButtonWrapper>
                )}

                {displaySummaryNote && (
                    <SummaryNote>
                        <Text mini lightWeight>
                            <Translator
                                tk="SUMMARY_NOTE"
                                withValues={{
                                    storeCode: countryCode?.toLowerCase(),
                                }}
                            />
                        </Text>
                    </SummaryNote>
                )}
            </SummaryColumn>
        </Row>
    </OrderTableSummaryWrapper>
);

export default connect((state, ownProps) => ({
    countryCode: activeStoreSelector(state, ownProps).country_code,
}))(CheckoutOrderTableSummary);
